import { computed, inject, Injectable, signal } from '@angular/core';
import { UserApi } from '@core/api';
import { TimezoneHelper } from '@shared/helpers';
import { CurrentUser } from '@shared/types';
import * as momentTz from 'moment-timezone';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
    private userApi = inject(UserApi);

    private _currentUser = signal<CurrentUser>({
        id: '',
        firstName: '',
        lastName: '',
        shortName: '',
        fullName: '',
        email: '',
        hasMarketingRole: false,
        omRoles: [],
        timeZoneName: '',
    });
    private _isUnauthorized = signal(false);

    readonly currentUser = computed(() => this._currentUser());
    readonly isUnauthorized = computed(() => this._isUnauthorized());

    async initializeCurrentUser(): Promise<CurrentUser | null> {
        if (this.currentUser().id) {
            return this.currentUser();
        }

        const response = await this.userApi.getCurrentUserDetails();
        if (response.data) {
            this.setCurrentUser(response.data);

            // @ts-expect-error - window.timeZoneOffset is a global variable
            window.timeZoneOffset = TimezoneHelper.computeTimezoneOffset(response.data.timeZoneName);
            momentTz.tz.setDefault(TimezoneHelper.windowsToIana(response.data.timeZoneName));

            return this.currentUser();
        }
        return null;
    }

    setCurrentUser(user: CurrentUser): void {
        this._currentUser.set(user);
    }

    triggerUnauthorizedError(value: boolean): void {
        this._isUnauthorized.set(value);
    }
}
